import { render, staticRenderFns } from "./nouveautes.html?vue&type=template&id=2c8fbec6&scoped=true&external"
import script from "./nouveautes.js?vue&type=script&lang=js&external"
export * from "./nouveautes.js?vue&type=script&lang=js&external"
import style0 from "./nouveautes.scss?vue&type=style&index=0&id=2c8fbec6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8fbec6",
  null
  
)

export default component.exports